(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    // `?topic=events` preselects the first option whose handle starts with "events". Runs once per
    // form; an unmatched or absent topic leaves the "Choose one" prompt, which is the default
    // without JavaScript too.
    function handleize(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/&/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function preselectTopic(form) {
      var select = form.querySelector('[data-topic-select]');
      if (!select || select.value) return;
      var wanted = handleize(new URLSearchParams(window.location.search).get('topic'));
      if (!wanted) return;
      var match = Array.prototype.find.call(select.options, function (option) {
        return option.dataset.topicKey && option.dataset.topicKey.indexOf(wanted) === 0;
      });
      if (match) select.value = match.value;
    }

    // Inline errors. The browser's own validation stays on until this runs, so a visitor without
    // JavaScript still cannot send an empty form; once it runs, it replaces the browser's bubbles
    // with the message under the field and keeps it in the accessibility tree.
    function messageFor(field, fields) {
      if (field.validity.valueMissing) return field.dataset.msgMissing || fields.dataset.msgRequired;
      if (field.validity.typeMismatch) return fields.dataset.msgEmail;
      return field.validationMessage;
    }

    function showError(field, fields) {
      var slot = document.getElementById(field.id + '-error');
      if (field.checkValidity()) {
        field.removeAttribute('aria-invalid');
        if (slot) {
          slot.textContent = '';
          slot.hidden = true;
        }
        return true;
      }
      field.setAttribute('aria-invalid', 'true');
      if (slot) {
        slot.textContent = messageFor(field, fields);
        slot.hidden = false;
      }
      return false;
    }

    function wire(form) {
      if (form.dataset.sdwContactReady) return;
      form.dataset.sdwContactReady = 'true';
      preselectTopic(form);

      var fields = form.querySelector('.contact-form__fields');
      if (!fields) return;
      form.noValidate = true;

      // Capture phase, and stopped when invalid: Shopify attaches its own spam-challenge handler to
      // contact forms, and a handler that runs first can submit the form itself and walk around
      // this check. At the target, capture listeners run before bubble ones.
      form.addEventListener(
        'submit',
        function (event) {
          var invalid = [];
          form.querySelectorAll('[required]').forEach(function (field) {
            if (!showError(field, fields)) invalid.push(field);
          });
          var summary = fields.querySelector('[data-summary]');
          if (invalid.length) {
            event.preventDefault();
            event.stopImmediatePropagation();
            // Focus reads the first field's own error; the summary says how many there are, so a
            // screen-reader user is not left to find the rest by tabbing.
            if (summary) {
              summary.textContent =
                invalid.length === 1
                  ? fields.dataset.msgSummaryOne
                  : fields.dataset.msgSummaryMany.replace('[n]', invalid.length);
            }
            invalid[0].focus();
            return;
          }
          if (summary) summary.textContent = '';
          // One send per press: Shopify's spam challenge can hold the submit for a moment, and a
          // second press in that moment would send the message twice.
          if (form.dataset.sdwSending) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          form.dataset.sdwSending = 'true';
          var button = form.querySelector('[type="submit"]');
          if (button) button.setAttribute('aria-busy', 'true');
        },
        true
      );

      // Once a field has been marked wrong, clear the message as soon as it is right.
      form.addEventListener('input', function (event) {
        var field = event.target;
        if (field.matches && field.matches('[required][aria-invalid="true"]')) showError(field, fields);
      });
    }

    function init() {
      document.querySelectorAll('form[data-sdw-contact]').forEach(wire);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
